import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import pick from 'lodash/pick';
import Advanced from './Advanced';
import Simple from './Simple';
import Vehicle from './Vehicle';
import s from '../../../redux/selectors';
import a from '../../../redux/actions';
import types from '../../../types';
import { wrap, withT } from '../../../lib/wrappers';
import NavButtons from '../../common/NavButtons.tsx';
import { CustomizableButton } from '../../common/Customizable';

const Travel = ({
  t,
  _t,
  addVehicle,
  updateNumericInput,
  vehicles,
  canAddMoreVehicles,
  isTravelUiSimple,
  ui,
}) => (
  <div className="cc-component" id="travel">
    <header className="cc-component__header">
      <span className="cc-component__byline">{t('How do you get around?')}</span>
    </header>

    <div className="cc-component__form">
      <div className="panel panel-default">
        <div className="panel-heading travel__vehicles-heading">
          <span>{t('Your Vehicles')}</span>
          <button
            id="travel__add_vehicle"
            className="btn btn-default btn-xs"
            onClick={addVehicle}
            disabled={!canAddMoreVehicles}
          >
            <i className="fa fa-plus" />&nbsp;
            {t('add')}
          </button>
        </div>
        <div className="panel-body">
          {vehicles.map((vehicle, i) =>
            <Vehicle
              key={vehicle.index}
              isLastVehicle={i === vehicles.length - 1}
              vehicle={vehicle}
            />,
            )}
        </div>
      </div>

      <div className="cc-simple-advanced-container">
        <div className="btn-group" role="group" aria-label="...">
          <CustomizableButton
            ui={ui}
            type="button"
            className={classnames('btn', { 'btn-default': !isTravelUiSimple, 'btn-success': isTravelUiSimple })}
            onClick={() =>
              updateNumericInput({ transportation_groundtype: 0, transportation_airtype: 0 })
            }
          >{_t('Simple').startCase()}</CustomizableButton>
          <CustomizableButton
            ui={ui}
            type="button"
            className={classnames('btn', { 'btn-default': isTravelUiSimple, 'btn-success': !isTravelUiSimple })}
            onClick={() =>
              updateNumericInput({ transportation_groundtype: 1, transportation_airtype: 1 })
            }
          >{t('Advanced')}</CustomizableButton>
        </div>
      </div>

      {isTravelUiSimple && <Simple />}
      {!isTravelUiSimple && <Advanced />}
    </div>
    <NavButtons ui={ui} />
  </div>
);

Travel.propTypes = {
  t: PropTypes.func.isRequired,
  _t: PropTypes.func.isRequired,
  addVehicle: PropTypes.func.isRequired,
  updateNumericInput: PropTypes.func.isRequired,

  vehicles: types.Vehicles.isRequired,
  canAddMoreVehicles: PropTypes.bool.isRequired,
  isTravelUiSimple: PropTypes.bool.isRequired,
  ui: PropTypes.any,
};

const mapStateToProps = (state, ownProps) => [
  'vehicles',
  'canAddMoreVehicles',
  'isTravelUiSimple',
  'ui',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = dispatch => bindActionCreators(
  pick(a, [
    'addVehicle',
    'updateNumericInput',
  ]),
  dispatch,
);

export default wrap(
  withT('travel'),
  connect(mapStateToProps, mapDispatchToProps)(Travel),
);
